import { 
  Card, 
  Table, 
  Row,
  Col,
  message,
  Pagination,
  Steps, 
  PageHeader, 
  Spin,
  Tag,
} from 'antd'
import React, { useEffect, useState } from 'react';
import { FileTextOutlined, FormOutlined } from '@ant-design/icons';
import { useLocation } from "react-router-dom";
import QueryString from "qs";
import ProductTable from '../components/ProductTable';
import BasicDescription from '../components/BasicDescription';
import service from '../../../@services';
import EditDeliveryNo from './components/EditDeliveryNo'
import DeliveryInfo from './components/DeliveryInfo'
import './index.less'

const OrderDetail = (props) => {
  const { search } = useLocation()
  let query = QueryString.parse(decodeURIComponent(search.replace("?", "")))

  const orderChan = query?.orderChan;
  const detail = {
    isDelivery: query?.isDelivery,
    orderNo: query?.orderNo,
    orderStatus: query?.orderStatus
  }

  const [loading, setLoading] = useState(false)
  const [pager, setPager] = useState({
    pageIndex: 1,
    pageSize: 5,
    pageCount: 0
  })
  const [editDeliveryNoVisible, setEditDeliveryNoVisible] = useState(false) // 编辑单号（弹窗）
  const [deliveryInfoVisible, setDeliveryInfoVisible] = useState(false) // 物流信息（弹窗）
  const [orderDetail, setOrderDetail] = useState({})
  const [orderStatusList, setOrderStatusList ] = useState([])
  const [editDeliveryNoDetail, setEditDeliveryNoDetail] = useState({})
  const [deliveryInfoDetail, setDeliveryInfoDetail] = useState({})
  const [orderStep, setOrderStep] = useState(1)
  const [newOrderStatus, setNewOrderStatus] = useState([])
  const { Step } = Steps
  
  /* 基本信息（字段列表）*/
  const baseInfoFileds = [
    {
      label: '订单来源',
      value: 'chan',
      render: text =>
        ((orderChan || []).filter(item => item.code == text)[0] || []).name
    },
    {
      label: '订单类型',
      value: 'orderTypeName'
    },
    { label: '下单时间', value: 'orderTime' },
    {
      label: '订单状态',
      value: 'orderStatusName'
    },
    {
      label: '支付方式',
      value: 'payWays',
      span: 2,
      contentStyle: { flexDirection: 'column' },
      render: text =>
        text && text.map((item, index) => <div key={index}>{item}</div>)
    },
    { label: '收银员', value: 'cashierName' },
    { label: '配送方式', value: 'receiveWay' },
    { label: '购买人姓名', value: 'buyerName' },
    { label: '购买人电话', value: 'buyerPhone' },
    { label: '收件人', value: 'receiverName' },
    { label: '联系方式', value: 'receiverPhone' },
    { label: '收货地址', value: 'receiverDetailAddr' },
    { label: '核销码', value: 'verifyCode' }
  ]
  /* 操作日志（字段列表） */
  const operLogColumns = [
    {
      title: '操作类型',
      dataIndex: 'operatorType',
      align: 'center'
    },
    {
      title: '操作描述',
      dataIndex: 'operDesc',
      align: 'center'
    },
    {
      title: '操作人',
      dataIndex: 'operatorName',
      align: 'center'
    },
    {
      title: '操作时间',
      dataIndex: 'operTime',
      align: 'center'
    }
  ]
  /* 物流信息（字段列表） */
  const deliveryColumns = [
    {
      title: '商品编码',
      dataIndex: 'skuNo'
    },
    {
      title: '商品名称',
      dataIndex: 'productName',
      width: 320
    },
    {
      title: '数量',
      dataIndex: 'count'
    },
    {
      title: '规格',
      dataIndex: 'spec'
    },
  ]
  const [tableDataDelivery, setTableDataDelivery] = useState([])

  const getDeliveryList = async () => {
    const data = {
      ...pager,
      orderNo: detail.orderNo
    }
    const res = await service.orderSend.orderDeliveryInfo(data)
    if(res) {
      setPager({
        ...pager,
        pageCount: res.pageCount
      })
      setTableDataDelivery(res.result)
    }
  }
  /* 编辑 物流单号 */
  const onEditDeliveryNo = (item, index) => {
    setEditDeliveryNoDetail(item)
    setEditDeliveryNoVisible(true)
  }
  /* 查看 物流信息 */
  const onDeliveryInfo = (item, index) => {
    setDeliveryInfoDetail(item)
    setDeliveryInfoVisible(true)
  }

  useEffect(() => {
    if (detail.orderNo) {
      const api = detail.isDelivery
        ? service.delivery.detailByNo(detail.orderNo)
        : service.order.getOrderDetail(detail.orderNo)

      api
        .then(res => {
          setOrderDetail(res || {})
          setLoading(false)

          if (res) {
            if(res.receiveWay === '快递配送' && (res.orderStatusName === '待收货' || 
              res.orderStatusName === '部分发货' || res.orderStatusName === '已完成')) {
              getDeliveryList()
            }

            let orderStatusMap = []
            if(res.allAfter) {
              /* 全部退货 */
              orderStatusMap = [
                { key: 'wait_pay', value: '待付款' },
                { key: 'wait_delivery', value: '待发货' },
                { key: 'cancel', value: '已取消' }
              ]
            }else {
              /* 部分退货 */
              orderStatusMap = [
                { key: 'wait_pay', value: '待付款' },
                { key: 'wait_delivery', value: '待发货' },
                { key: 'wait_take', value: '待收货' },
                { key: 'finish', value: '已完成' }
              ]
            }

            orderStatusMap.forEach((item, index) => {
              if(item.key == res.orderStatus) {
                if(res.orderStatus == 'cancel') {
                  orderStatusMap[orderStatusMap.length - 1] = { key: 'cancel', value: '已取消' }
                }
                setOrderStep(index)
              }
            })

            const orderStatusListTemp = orderStatusMap.map((item, index) => {
              return item.value
            })
            setOrderStatusList(orderStatusListTemp)



            // if (res.chan === 'tc_online') {
            //   if (res.orderStatus === 'cancel') {
            //     const cancelStep = res.traces[res.traces.length - 2].operTag
            //     let orderStep = 0
            //     const orderStatusOptions = []
            //     let OrderStatusMap = []
            //     if (res.orderType === 2) {
            //       OrderStatusMap = [
            //         { key: 'wait_pay', value: '待付款' },
            //         { key: 'wait_group', value: '待成团' },
            //         { key: 'grouped', value: '已成团' },
            //         { key: 'wait_take', value: '待自提' },
            //         { key: 'finish', value: '已完成' }
            //       ]
            //     } else if (res.orderType === 3) {
            //       if (res.receiveWay === '门店自提') {
            //         OrderStatusMap = [
            //           { key: 'wait_pay', value: '待付款' },
            //           { key: 'wait_take', value: '待自提' },
            //           { key: 'finish', value: '已完成' },
            //         ]
            //       } else {
            //         OrderStatusMap = [
            //           { key: 'wait_pay', value: '待付款' },
            //           { key: 'wait_delivery', value: '待发货' },
            //           { key: 'wait_take', value: '待自提' },
            //           { key: 'finish', value: '已完成' }
            //         ]
            //       }
            //     }
            //     for (let i = 0; i < OrderStatusMap.length; i++) {
            //       const item = OrderStatusMap[i]
            //       if (res.receiveWay === '快递配送' && item.key === 'wait_take') item.value = '待收货'
            //       if (i === 2 && res.receiveWay === '门店自提' && res.orderType === 3 && cancelStep !== 'finish') {
            //         OrderStatusMap.splice(2, 1)
            //         orderStep = i + 1
            //         break
            //       }

            //       orderStatusOptions.push(item.value)
            //       if (item.key === cancelStep || item.value === cancelStep) {
            //         orderStep = i + 1
            //         break
            //       }
            //     }
            //     orderStatusOptions.push('已取消')
            //     setNewOrderStatus(orderStatusOptions)
            //     setOrderStep(orderStep + 1)
            //   } else {
            //     let OrderStatusMap = []
            //     if (res.orderType === 2) {
            //       OrderStatusMap = [
            //         { key: 'wait_pay', value: '待付款' },
            //         { key: 'wait_group', value: '待成团' },
            //         { key: 'grouped', value: '已成团' },
            //         { key: 'wait_take', value: '待自提' },
            //         { key: 'finish', value: '已完成' }
            //       ]
            //     } else if (res.orderType === 3) {
            //       if (res.receiveWay === '门店自提') {
            //         OrderStatusMap = [
            //           { key: 'wait_pay', value: '待付款' },
            //           { key: 'wait_take', value: '待自提' },
            //           { key: 'finish', value: '已完成' },
            //         ]
            //       } else {
            //         OrderStatusMap = [
            //           { key: 'wait_pay', value: '待付款' },
            //           { key: 'wait_delivery', value: '待发货' },
            //           { key: 'wait_take', value: '待自提' },
            //           { key: 'finish', value: '已完成' }
            //         ]
            //       }
            //     }

            //     const orderStatusOptions = OrderStatusMap.map((item, index) => {
            //       if (res.orderStatus.indexOf(item.key) > -1) {
            //         setOrderStep(index)
            //       }
            //       if (res.receiveWay === '快递配送' && item.key === 'wait_take') {
            //         item.value = '待收货'
            //       }
            //       return item.value
            //     })
            //     setNewOrderStatus(orderStatusOptions)
            //   }
            // } else {
            //   res.orderStatus === 'finish' && setOrderStep(2)
            // }
          }
        })
        .catch(e => {
          setLoading(false)
        })
    } else {
      setLoading(false)
      setOrderDetail({})
      setOrderStep(0)
    }
  }, [])
  return (
    <div className="order-detail-page">
      <Card className="step-wrapper">
        <Spin spinning={loading}>
          <PageHeader
            title={
              <>
                <FileTextOutlined
                  style={{ color: '#1890FF', marginRight: '5px' }}
                />
                <span style={{ color: '#1890FF' }}>
                  订单号：{orderDetail.orderNo}
                </span>
              </>
            }
            tags={
              orderDetail.orderStatusName && (
                <Tag color='green'>
                  { orderDetail.orderStatusName == '部分发货' ? '待发货' : orderDetail.orderStatusName }
                </Tag>
              )
            }>

            <Steps labelPlacement='vertical' current={orderStep} size='small'>
            {orderStatusList &&
                  orderStatusList.map(item => {
                    return <Step key={item} title={item} description={''} />
                  })}
            </Steps> 
            {/* {orderDetail.chan === 'tc_online' ? (
              <Steps labelPlacement='vertical' current={orderStep} size='small'>
                {newOrderStatus &&
                  newOrderStatus.map(item => {
                    return <Step key={item} title={item} description={''} />
                  })}
              </Steps>
            ) : (
              <Steps labelPlacement='vertical' current={orderStep} size='small'>
                <Step title='待付款' />
                <Step title='已完成' />
              </Steps>
            )} */}
          </PageHeader>
        </Spin>
      </Card>

      <Card className="baseinfo-wrapper mt-10">
        <PageHeader className='detail-head' title='订单基础信息'>
          <BasicDescription
            detail={orderDetail}
            column={{ xs: 1, sm: 2, md: 3 }}
            fileds={baseInfoFileds}
          />
        </PageHeader>
      </Card>

      <Card 
        className="delivery-info-wrapper mt-10"
        style={{ display: orderDetail.receiveWay === '快递配送' && (orderDetail.orderStatusName === '待收货' || 
          orderDetail.orderStatusName === '已完成') ? 'block' : 'none'  }}
      >
        <PageHeader className='detail-head' title='物流信息'>
          <Row className='form-header bd-t bd-r bd-b bd-l' >
            <Col span={9} className='col'>
              <span>商品编码</span>
            </Col>
            <Col span={7} className='col'>
              <span>商品名称</span>
            </Col>
            <Col span={3} className='col'>
              <span>数量</span>
            </Col>
            <Col span={5} className='col'>
              <span>规格</span>
            </Col>
          </Row>
            
          {tableDataDelivery.map((item, index) => {
            return<div className='form-item-wrapper'>
              <Row className='form-item-header-row bd-t bd-r bd-l' >
                <Col span={24} className='form-item-header-col col'>
                  <div className="count">包裹{ item.deliveryNumber }</div>
                  <div className='ml-20'>{ item.deliveryCompany == 'jingdong' ? '京东物流' : item.deliveryCompany }</div>
                  <div className='ml-10'>{ item.deliveryCode }</div>
                  <FormOutlined 
                    className='edit-icon ml-10' 
                    onClick={() => onEditDeliveryNo(item, index)} 
                    style={{ display: ['已完成', '已取消'].includes(orderDetail.orderStatusName) ? 'none' : 'block' }}
                  />
                  <div 
                    className='view-delivery-info red-text ml-20' 
                    onClick={(e, index) => onDeliveryInfo(item, index)} 
                  >查询物流</div>
                </Col>
              </Row>

              <Row>
                <Col span={24}>
                  <Table 
                    size='middle' 
                    bordered 
                    dataSource={item.details} 
                    columns={deliveryColumns} 
                    className="table" 
                    pagination={{ position: ['none'] }} 
                    showHeader={false}
                  />
                </Col>
              </Row>
            </div>
          })}

          <div 
            className='pagination-box'
            style={{ display: pager.pageCount > 5 ? 'block' : 'none' }}
          >
            <Pagination defaultCurrent={1} total={500} />
          </div>
        </PageHeader>
      </Card>

      <Card className="product-info-wrapper mt-10">
        <PageHeader
          className='detail-head'
          title='商品信息'
          extra={
            <Row>
              共
              <span className='primary-text'>
                {(orderDetail &&
                  orderDetail.details &&
                  orderDetail.details.length) ||
                  0}
              </span>
              种商品，总金额
              <span className='primary-text'>
                {orderDetail.productAmount || 0}
              </span>
              元， 实付金额
              <span className='primary-text'>{orderDetail.payAmount || 0}</span>
              元
            </Row>
          }>
          <ProductTable data={orderDetail.details || []} />
          <div className='detail-row'>
            <span>商品总金额</span>
            <span>￥{orderDetail.productAmount || 0}</span>
          </div>
          <div className='detail-row'>
            <span>包装费</span>
            <span>￥{orderDetail.packageAmount || 0}</span>
          </div>
          <div className='detail-row'>
            <span>配送费</span>
            <span>￥{orderDetail.freightAmount || 0}</span>
          </div>
          <div className='detail-row right'>
            <span>实付总金额</span>
            <span style={{ marginLeft: '20px' }}>
              ￥{orderDetail.payAmount || 0}
            </span>
          </div>
          <div className='detail-row'>
            用户留言：{orderDetail.buyerRemark || '-'}
          </div>
        </PageHeader>
      </Card>

      <Card className="oper-log-wrapper mt-10">
        <PageHeader className='detail-head' title='操作日志'>
          <Table
            rowKey={record => record.operTag + record.operTime}
            size='middle'
            bordered
            columns={ operLogColumns }
            dataSource={ orderDetail.traces || [] }
            pagination={ false }
          />
        </PageHeader>
      </Card>

      <DeliveryInfo
        visible={deliveryInfoVisible}
        onClose={() => setDeliveryInfoVisible(false)}
        detail={deliveryInfoDetail}
        baseInfo={orderDetail}
      />
      <EditDeliveryNo
        visible={editDeliveryNoVisible}
        onClose={() => setEditDeliveryNoVisible(false)}
        onGetDetail={() => getDeliveryList()}
        detail={editDeliveryNoDetail}
      />
    </div>
  )
}
export default OrderDetail
